import React, { useEffect, useState } from 'react';
import './DataBar.css';
import Total from './Components/Total/Total';
import Pending from './Components/Pending/Pending';
import InProgress from './Components/In-Progress/InProgress';
import Completed from './Components/Completed/Completed';
import TaskService from '../../../../../../../../AppSettings/services/TaskService';
import { useParams } from 'react-router-dom';
import { TaskStatus } from '@frontend/Models/Tasks/TaskModels';
import { isLegalEnvironment } from '../../../../../../../../AppSettings/environmentConfig';

interface DataBarProps {
  setActiveTable: (table: string) => void;
  onStatusFilter: (status: string) => void;
  currentStatusFilter: string | null;
}

const DataBar: React.FC<DataBarProps> = ({
  setActiveTable,
  onStatusFilter,
  currentStatusFilter,
}) => {
  const { matterId } = useParams<{ matterId: string }>();
  const [taskStatuses, setTaskStatuses] = useState<TaskStatus[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!matterId) return;

    const fetchTaskStatuses = async () => {
      try {
        const data: TaskStatus[] =
          await TaskService.getTaskStatusDistributionByMatterId(matterId);
        setTaskStatuses(data);
      } catch (error) {
        console.error('Error fetching task statuses:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTaskStatuses();
  }, [matterId]);

  const getCount = (status: string) => {
    const task = taskStatuses.find((t) => t.status === status);
    return task ? task.count : 0;
  };

  const totalCount = ['Pending', 'In Progress', 'Completed'].reduce(
    (acc, status) => acc + getCount(status),
    0
  );

  const handleStatusClick = (status: string) => {
    onStatusFilter(status);
  };

  if (loading) {
    return <div>Loading...</div>; // Or a proper loading component
  }

  return (
    <div className="task-data-bar">
      {isLegalEnvironment && (
        <div
          className={`task-data-bar-item data-bar-total ${
            currentStatusFilter === 'Total' ? 'active' : ''
          }`}
          onClick={() => handleStatusClick('Total')}
        >
          <Total
            count={totalCount}
            isActive={currentStatusFilter === 'Total'}
          />
        </div>
      )}
      <div
        className={`task-data-bar-item data-bar-pending ${
          currentStatusFilter === 'Pending' ? 'active' : ''
        }`}
        onClick={() => handleStatusClick('Pending')}
      >
        <Pending
          count={getCount('Pending')}
          isActive={currentStatusFilter === 'Pending'}
        />
      </div>
      <div
        className={`task-data-bar-item data-bar-inprogress ${
          currentStatusFilter === 'In Progress' ? 'active' : ''
        }`}
        onClick={() => handleStatusClick('In Progress')}
      >
        <InProgress
          count={getCount('In Progress')}
          isActive={currentStatusFilter === 'In Progress'}
        />
      </div>
      <div
        className={`task-data-bar-item data-bar-completed ${
          currentStatusFilter === 'Completed' ? 'active' : ''
        }`}
        onClick={() => handleStatusClick('Completed')}
      >
        <Completed
          count={getCount('Completed')}
          isActive={currentStatusFilter === 'Completed'}
        />
      </div>
    </div>
  );
};

export default DataBar;
